module.exports = __webpack_public_path__ + "img/earth-americas.582b5a9e.svg";